/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ShadowAccountAmiInfo } from './shadowAccountAmiInfo';


export interface ShadowAccountAMIList { 
    /**
     * Admin Account AMIs shared with shadow Account
     */
    admin_shared_amis?: Array<ShadowAccountAmiInfo>;
    /**
     * Shadow Account AMIs
     */
    self_amis?: Array<ShadowAccountAmiInfo>;
}

